import { useSelector } from "react-redux";
function WordEngCard({ TextValue }) {
  const contentValue = useSelector((state) => state.contents.contentValues);
  const currentContent = contentValue?.contents?.[TextValue];
  return (
    <div
      className="bg-white rounded-2xl p-4 md:p-6 shadow-xl 
          hover:shadow-2xl transition-all w-full md:w-auto border-yellow-400 border-l-6"
    >
      <div>
        <span
          className="inline-block px-3 py-1 bg-purple-100
               text-purple-700 font-semibold rounded-lg text-md md:text-lg mb-2"
        >
          English
        </span>
        <p className="text-md md:text-lg text-gray-700 leading-relaxed">
          {currentContent?.Eng || "Loading..."}
        </p>
      </div>
    </div>
  );
}

export default WordEngCard;
